
import {Component, Vue, Prop, Watch} from "vue-property-decorator";
import {Getter} from "vuex-class";
import KeyBookedModal from "@/components/keys/KeyBookedModal.vue";

@Component({
    components: {
        KeyBookedModal,
    },
})
export default class RelayBookedKey extends Vue {
    @Prop({default: {}})
    public currentKey: any;

    @Getter private currentUser: any;
    @Getter private isAdmin: boolean;
    @Getter private isMobile: boolean;

    private quickBookedKeyDialog: boolean = false;

    private openModal() {
        this.quickBookedKeyDialog = true;
    }

    private closeModal() {
        this.quickBookedKeyDialog = false;
    }
}
